"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-7eaff010"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = ["id"];
const _hoisted_2 = {
    key: 0,
    class: "modal-header"
};
const _hoisted_3 = { class: "modal-header-wrapper" };
const _hoisted_4 = { class: "header-text" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "zmdi zmdi-close zmdi-hc-lg" }, null, -1 /* HOISTED */));
const _hoisted_6 = [
    _hoisted_5
];
const _hoisted_7 = {
    key: 1,
    class: "modal-divider"
};
const _hoisted_8 = { class: "modal-body" };
const _hoisted_9 = {
    key: 2,
    class: "modal-divider"
};
const _hoisted_10 = {
    key: 3,
    class: "modal-footer"
};
const vue_3 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'Modal',
    props: {
        modalName: {},
        hasTitleDivider: { type: Boolean },
        hasFooterDivider: { type: Boolean },
        includeModalFooter: { type: Boolean, default: true },
        includeModalHeader: { type: Boolean, default: true }
    },
    emits: ["close-modal", "confirm", "cancel"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const alertPadding = (0, vue_3.computed)(() => !props.hasTitleDivider ? 'alert-modal-padding' : '');
        function closeModal() {
            emit('close-modal');
        }
        function confirm() {
            emit('confirm');
        }
        function cancel() {
            emit('cancel');
        }
        __expose({ closeModal, confirm, cancel });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                id: _ctx.modalName,
                class: "oplus-modal modal active"
            }, [
                (0, vue_2.createElementVNode)("div", {
                    class: "modal-overlay",
                    "aria-label": "Close",
                    onClick: _cache[0] || (_cache[0] = ($event) => (closeModal()))
                }),
                (0, vue_2.createElementVNode)("div", {
                    class: (0, vue_2.normalizeClass)(["modal-container", alertPadding.value])
                }, [
                    (_ctx.includeModalHeader)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_2, [
                            (0, vue_2.createElementVNode)("div", _hoisted_3, [
                                (0, vue_2.createElementVNode)("span", _hoisted_4, [
                                    (0, vue_2.renderSlot)(_ctx.$slots, "header-title")
                                ]),
                                (0, vue_2.createElementVNode)("span", {
                                    class: "close-btn",
                                    "aria-label": "Close",
                                    onClick: _cache[1] || (_cache[1] = ($event) => (closeModal()))
                                }, _hoisted_6)
                            ]),
                            (0, vue_2.renderSlot)(_ctx.$slots, "header-icon")
                        ]))
                        : (0, vue_2.createCommentVNode)("v-if", true),
                    (_ctx.hasTitleDivider)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_7))
                        : (0, vue_2.createCommentVNode)("v-if", true),
                    (0, vue_2.createElementVNode)("div", _hoisted_8, [
                        (0, vue_2.renderSlot)(_ctx.$slots, "content")
                    ]),
                    (_ctx.hasFooterDivider)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_9))
                        : (0, vue_2.createCommentVNode)("v-if", true),
                    (_ctx.includeModalFooter)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_10, [
                            (0, vue_2.renderSlot)(_ctx.$slots, "footer-btn")
                        ]))
                        : (0, vue_2.createCommentVNode)("v-if", true)
                ], 2 /* CLASS */)
            ], 8 /* PROPS */, _hoisted_1));
        };
    }
});
